import { useSyncExternalStore } from 'react';

/** Синхронизация с `data-theme` на `<html>` для `data-color-mode` у @uiw/react-md-editor. */
export function useStaffColorMode(): 'light' | 'dark' {
  return useSyncExternalStore(
    (onStoreChange) => {
      const el = document.documentElement;
      const mo = new MutationObserver(() => onStoreChange());
      mo.observe(el, { attributes: true, attributeFilter: ['data-theme'] });
      return () => mo.disconnect();
    },
    () => (document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'),
    () => 'light'
  );
}
